
import { pick, omit, reduce, mapValues } from 'lodash'
// import queryString from 'query-string'
// import type { HashType } from 'flow/types'
import { AUTH_TOKEN_KEY } from '../constants/base'
import axios from 'axios';
import config from '../config';
import isEmpty from 'lodash/isEmpty';

const api = axios.create({
  baseURL: `${config.apiEndpoint}`
});

let commonJwtToken = localStorage.getItem(AUTH_TOKEN_KEY);
if (commonJwtToken)
  api.defaults.headers.common['Authorization'] = `Bearer ${commonJwtToken}`;


const definePostAffiliateProIdHeader = () => {
  if (isEmpty(api.defaults.headers['X-PAP-ID']) && !isEmpty(window.PostAffTracker) && window.PostAffTracker._getAccountId) {    
    const visitorID = window.PostAffTracker._cmanager.getVisitorIdOrSaleCookieValue()
    const papID = (window.PostAffTracker._getAccountId() || '') + window.PostAffTracker._cmanager.getVisitorIdOrSaleCookieValue()
    
    if (!isEmpty(visitorID) && !isEmpty(papID))
    	api.defaults.headers['X-PAP-ID'] = papID
  }
}
definePostAffiliateProIdHeader();

// Array with params needed to omit params that in path 
export function resolvePathAndParams(path, params = {}) {
  if (path instanceof Function){
    const pathRes = path.call(this, params)
    return (pathRes instanceof Array) ? pathRes : [pathRes, params]
  }
  return [path, params]
}


export function setAuthToken(token) {
  if (token) {
    commonJwtToken = token;
    localStorage.setItem(AUTH_TOKEN_KEY, commonJwtToken);
    api.defaults.headers.common['Authorization'] = `Bearer ${commonJwtToken}`;
  }
  else if (token === false){
    commonJwtToken = null;
    localStorage.removeItem(AUTH_TOKEN_KEY);
    api.defaults.headers.common['Authorization'] = null;
  }
  return
}

export function getAuthToken() {
  const token = commonJwtToken || localStorage.getItem(AUTH_TOKEN_KEY) || null
  return token // .replace(/Bearer /, '');
}


function updateAuthToken(response){
  const auth = response.headers && (response.headers['Authorization'] || response.headers['authorization'])
  if (auth){
    const token = auth.split(' ')[1]
    token && setAuthToken(token)
  }
  return
}




const isPostPutMethod = (method) => (method === 'post' || method === 'put' || method === 'patch')

function getRequestMethod (k) {
  switch (k){
    case 'create':
      return 'post';
    case 'update':
      return 'put';
    case 'destroy':
      return 'delete'; 
    default:
      return 'get';
  }
}

const ApiFetch = (path, allParams = {}, options = {}, reqMethod = 'get') => {
  const [url, params] = resolvePathAndParams(path, allParams);
  // const apiOptions = prepareApiOptions(reqMethod, params, options);
  definePostAffiliateProIdHeader()
  const request = isPostPutMethod(reqMethod) ? api[reqMethod](url, params, options) : api[reqMethod](url, {...options, params:params});
  return request.then( (response) => {
    updateAuthToken(response)
    return response.data && response.data.success === true && response.data.data ? response.data.data : response.data;
  });
}


export const Api = reduce(['get', 'post', 'put', 'delete'], (hash = {}, m = null) => {
  return {...hash, [m]:(path, allParams = {}, options = {}) => ApiFetch(path, allParams, options, m)}
}, {});

export function crudResourceConfig (basePathUrl, {only, basePathMutator} = {}) {
  const basePath = basePathMutator instanceof Function ? basePathMutator(basePathUrl) : basePathUrl
  const itemPath = (params) => [params.id ? `${resolvePathAndParams(basePath, omit(params, ['id']))[0]}/${params.id}` : basePath, omit(params, ['id'])]
  
  const crudDefaultConfig = {
    // index: basePath,
    list: basePath,
    create: basePath,
    get: itemPath,
    update: itemPath,
    destroy: itemPath
  }
  
  return (only) ? pick(crudDefaultConfig, only) : crudDefaultConfig;
}

export function crudCreator (config, options = {}) {
  // const { unpack } = options;
  
  return mapValues( config, (path, crudMethod) => {
    const reqMethod = getRequestMethod(crudMethod);
    return (allParams = {}) => Api[reqMethod](path, allParams, options)
  });
}

export function crudResourceCreator (basePath, { only, basePathMutator, ...options } = {}) {
  const crudConfig = crudResourceConfig(basePath, {only, basePathMutator});
  return crudCreator(crudConfig, options)
}




// WEBPACK FOOTER //
// ./src/api/apiHelper.js